import type { ComponentChildren } from 'preact'
import { useId } from 'preact/hooks'
import styles from './screen-panel.module.css'

interface ScreenPanelProps {
  readonly title: ComponentChildren
  readonly children?: ComponentChildren
  /** Actions, usually `Button`s. Right-aligned; stacked full-width on compact screens. */
  readonly footer?: ComponentChildren
}

/**
 * The centered panel every menu screen uses. Scrolls inside when taller than the viewport.
 * `data-screen` marks it for gamepad focus navigation (`app/use-ui-intents.ts`).
 */
export function ScreenPanel({ title, children, footer }: ScreenPanelProps) {
  const titleId = useId()
  return (
    <div class={styles.screen} data-screen>
      <section class={styles.panel} aria-labelledby={titleId}>
        <h1 id={titleId} class={styles.title}>
          {title}
        </h1>
        {children !== undefined && <div class={styles.body}>{children}</div>}
        {footer !== undefined && <footer class={styles.footer}>{footer}</footer>}
      </section>
    </div>
  )
}
